export default __webpack_public_path__ + "static/media/olympus-badge.572c14db.svg";